<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

html,body{
  padding: 0;
  margin: 0;
  font-family: "Source Han Sans CN", "Microsoft Yahei", "PingHei", "Lucida Grande", "Lucida Sans Unicode";
}
</style>



// WEBPACK FOOTER //
// src/App.vue